<p-toast></p-toast>

<div class="dispute-review-page quotation-detail-page" *ngIf="detail as d">
    <div class="sticky-toolbar mb-8 text-[14px]">
        <p-toolbar class="text-[14px] p-0">
            <ng-template pTemplate="start">
                <div class="left-buttons">
                    <h5 class="dispute-toolbar-title">
                        Draft order {{ d.quotationNumber }}
                        <span class="customer-bit" *ngIf="d.customerName || d.customerId">
                            — {{ d.customerName || d.customerId }}
                        </span>
                    </h5>
                    <app-quotation-status-badge [status]="d.status"></app-quotation-status-badge>
                </div>
            </ng-template>
            <ng-template pTemplate="end">
                <div class="right-buttons">
                    <p-button
                        label="Reject draft order"
                        icon="pi pi-times"
                        severity="danger"
                        [outlined]="true"
                        [disabled]="!canReject"
                        (onClick)="openRejectDialog()"
                    ></p-button>
                    <p-button
                        label="Process"
                        icon="pi pi-check"
                        [disabled]="!canPunch"
                        (onClick)="punchAsOrder()"
                    ></p-button>
                    <p-button
                        label="Back"
                        icon="pi pi-arrow-left"
                        severity="secondary"
                        (onClick)="backToList()"
                    ></p-button>
                </div>
            </ng-template>
        </p-toolbar>
    </div>

    <div class="detail-grid">
        <section class="dispute-card lines-card">
            <h3 class="dispute-section-title">All line items ({{ d.lines?.length || 0 }})</h3>
            <p class="dispute-muted punch-hint">
                Stock and item checks run on the order screen after you punch.
            </p>
            <table class="lines-table">
                <thead>
                    <tr>
                        <th>Item no</th>
                        <th>Description</th>
                        <th>Requested qty</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let line of d.lines">
                        <td>{{ line.itemNumber }}</td>
                        <td>{{ line.itemName || '—' }}</td>
                        <td>{{ line.qty }}</td>
                    </tr>
                </tbody>
            </table>
        </section>

        <aside class="side-stack">
            <div class="dispute-card">
                <h3 class="dispute-section-title">Customer</h3>
                <dl class="meta">
                    <div><dt>Code</dt><dd>{{ d.customerId || '—' }}</dd></div>
                    <div><dt>Name</dt><dd>{{ d.customerName || '—' }}</dd></div>
                    <div><dt>Warehouse</dt><dd>{{ d.warehouse || '—' }}</dd></div>
                </dl>
            </div>
            <div class="dispute-card" *ngIf="d.punchedOrderNumber">
                <h3 class="dispute-section-title">Punched order</h3>
                <p><strong>{{ d.punchedOrderNumber }}</strong></p>
                <p class="dispute-muted" *ngIf="d.punchedAt">{{ d.punchedAt | date: 'MMM d, y, h:mm a' }}</p>
            </div>
            <div class="dispute-card">
                <h3 class="dispute-section-title">Timeline</h3>
                <ul class="timeline" *ngIf="d.timeline?.length; else noTimeline">
                    <li *ngFor="let ev of d.timeline">
                        <strong>{{ ev.newStatus }}</strong>
                        <span class="dispute-muted">{{ ev.changedAt | date: 'MMM d, y, h:mm a' }}</span>
                        <div *ngIf="ev.comment">{{ ev.comment }}</div>
                        <div class="dispute-muted" *ngIf="ev.changedBy">{{ ev.changedBy }}</div>
                    </li>
                </ul>
                <ng-template #noTimeline>
                    <p class="dispute-muted">No status history yet.</p>
                </ng-template>
            </div>
            <div class="dispute-card">
                <h3 class="dispute-section-title">Notes</h3>
                <p class="dispute-muted">
                    Draft order received via mobile app
                    <span *ngIf="d.createdBy"> by {{ d.createdBy }}</span>
                    <span *ngIf="d.submittedAt || d.createdAt">
                        on {{ (d.submittedAt || d.createdAt) | date: 'MMM d, y, h:mm a' }}.
                    </span>
                </p>
            </div>
        </aside>
    </div>
</div>

<p-dialog
    header="Reject draft order"
    [(visible)]="rejectDialogVisible"
    [modal]="true"
    [style]="{ width: '28rem' }"
>
    <label for="rejectMsg">Message for customer</label>
    <textarea
        id="rejectMsg"
        pTextarea
        rows="4"
        class="w-full"
        [(ngModel)]="rejectMessage"
        placeholder="Explain why this draft order is rejected"
    ></textarea>
    <ng-template pTemplate="footer">
        <p-button label="Cancel" severity="secondary" (onClick)="rejectDialogVisible = false"></p-button>
        <p-button label="Reject" severity="danger" (onClick)="confirmReject()"></p-button>
    </ng-template>
</p-dialog>
